module.exports = __webpack_public_path__ + "img/ez-theme-switcher-ic-deposit-bg.b385841e.b385841e.png";